import React, { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useParams, Link } from "react-router-dom";
import { authFetch } from '../auth';


const formatDateTime = (isoString) => {
  if (!isoString) return "-";
  const date = new Date(isoString);
  return date.toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};
// Форматируем время из секунд в "X мин Y сек"
const formatTime = (seconds) => {
  if (seconds === null || seconds === undefined) return "-";
  if (seconds < 60) return `${seconds} сек`;
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return secs === 0 ? `${mins} мин` : `${mins} мин ${secs} сек`;
};

// Выводим поля, если данных нет — "-"
const displayField = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return value;
};

const FlyPage = () => {
  const { id } = useParams();
  const [fly, setFly] = useState({});
  
  const [displayData, setDisplayData] = useState([]);
  
  const [menuOpen, setMenuOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const publicUrl = fly.publicId
    ? `${window.location.origin}/publicfly/${fly.publicId}`
    : "";

  useEffect(() => {
  if (!localStorage.getItem("token")) return;

  authFetch("/api/flydata/" + id)
    .then((response) => response.json())
    .then((data) => {
      setFly(data);
    });
}, [id]);

  const modalOverlayStyle = {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.65)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
  };

  const menuItemStyle = {
    padding: "10px",
    cursor: "pointer",
    color: "#F3F4F6",
    borderRadius: "8px",
    transition: "background 0.2s",
    textAlign: "left",
  };
  const modalTitleStyle = {
    fontSize: "22px",
    marginBottom: "20px",
  };
  const inputStyle = {
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid rgba(255,255,255,0.2)",
    backgroundColor: "rgba(31, 41, 55, 0.9)",
    color: "#F3F4F6",
    outline: "none",
  };
  const cancelBtnStyle = {
    flex: 1,
    padding: "12px",
    borderRadius: "10px",
    border: "1px solid rgba(255,255,255,0.2)",
    backgroundColor: "transparent",
    color: "#F3F4F6",
    cursor: "pointer",
  };
  const modalStyle = {
    backgroundColor: "rgba(17, 24, 39, 0.95)",
    borderRadius: "16px",
    padding: "30px",
    width: "100%",
    maxWidth: "420px",
    boxShadow: "0 20px 40px rgba(0,0,0,0.6)",
    color: "#F3F4F6",
  };

  const handleCopyLink = async () => {
    try {
      // Если браузер поддерживает Clipboard API и страница в безопасном контексте
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(publicUrl);
      } else {
        // Fallback для небезопасного контекста (HTTP) или старых браузеров
        const textArea = document.createElement("textarea");
        textArea.value = publicUrl;
        textArea.style.position = "fixed"; // чтобы не скроллилось
        textArea.style.left = "-9999px"; // чтобы было вне видимой области
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        const successful = document.execCommand("copy");
        document.body.removeChild(textArea);

        if (!successful) throw new Error("Fallback copy failed");
      }

      // Если удалось скопировать
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);

    } catch (err) {
      alert("Не удалось скопировать ссылку");
      console.error(err);
    }
  };



  const handleDelete = async () => {
    try {
      const response = await authFetch("/api/flydata/" + id, { method: "DELETE" });
      if (!response.ok) throw new Error("Ошибка удаления");
      alert("Полет успешно удалён");
      window.location.href = "/tunnel";
    } catch (error) {
      alert("Не удалось удалить полет");
      console.error(error);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: "100vh",
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "20px",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      <div
        style={{
          width: "95%",
          maxWidth: "1200px",
          backgroundColor: "rgba(42, 18, 99, 0.69)",
          borderRadius: "20px",
          border: "1px solid rgba(255,255,255,0.2)",
          boxShadow: "0 6px 20px rgba(0, 0, 0, 0.3)",
          padding: "30px",
          position: "relative",
        }}
      >
        {/* Три точки */}
        <div style={{ position: "absolute", top: "20px", right: "20px" }}>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            style={{
              background: "transparent",
              border: "none",
              color: "#fff",
              fontSize: "22px",
              cursor: "pointer",
            }}
          >
            ⋮
          </button>

          {menuOpen && (
            <div
              style={{
                position: "absolute",
                right: 0,
                marginTop: "10px",
                background: "#111",
                borderRadius: "10px",
                boxShadow: "0 8px 20px rgba(0,0,0,0.6)",
                padding: "10px",
                minWidth: "140px",
                zIndex: 1000,
              }}
            >
              <div
                style={menuItemStyle}
                onClick={() => {
                  setShareModalOpen(true);
                  setMenuOpen(false);
                }}
              >
                🔗 Поделиться
              </div>

              <div
                style={{
                  padding: "8px",
                  cursor: "pointer",
                  color: "#DC2626",
                  fontWeight: "bold",
                }}
                onClick={() => {
                  setMenuOpen(false);
                  setConfirmOpen(true);
                }}
              >
                🗑 Удалить
              </div>
            </div>
          )}
          {shareModalOpen && (
            <div
              style={modalOverlayStyle}
              onClick={() => {
                setShareModalOpen(false);
                setCopied(false);
              }}
            >
              <div
                style={modalStyle}
                onClick={(e) => e.stopPropagation()}
              >
                <h3 style={modalTitleStyle}>Поделиться полетом</h3>

                <input
                  type="text"
                  value={publicUrl}
                  readOnly
                  style={{
                    ...inputStyle,
                    marginBottom: "15px",
                    cursor: "pointer"
                  }}
                  onClick={(e) => e.target.select()}
                />

                <button
                  onClick={handleCopyLink}
                  style={{
                    width: "100%",
                    padding: "12px",
                    borderRadius: "10px",
                    border: "none",
                    backgroundColor: "#10B981",
                    color: "white",
                    fontWeight: "600",
                    cursor: "pointer"
                  }}
                >
                  {copied ? "✅ Скопировано!" : "📋 Скопировать"}
                </button>

                <button
                  onClick={() => {
                    setShareModalOpen(false);
                    setCopied(false);
                  }}
                  style={{
                    ...cancelBtnStyle,
                    marginTop: "12px",
                    width: "100%"
                  }}
                >
                  Закрыть
                </button>
              </div>
            </div>
          )}
        </div>

        <h2 style={{ textAlign: "center", marginBottom: "20px", color: "#fff" }}>
          Подробности о полете
        </h2>


        {/* Информация о прыжке - логические блоки */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            marginTop: "20px",
            gap: "15px",
          }}
        >
          {/* Локация */}
          <div style={{ flex: "1 1 250px", background: "rgba(17,17,17,0.6)", padding: "15px", borderRadius: "12px", border: "1px solid rgba(255,255,255,0.2)", color: "#fff" }}>
            <p><strong>Аэротруба:</strong> {displayField(fly.windtunnel)}</p>
            <p><strong>Страна:</strong> {displayField(fly.country)}</p>
            <p><strong>Город:</strong> {displayField(fly.city)}</p>
          </div>

          {/* Прыжок и аппарат */}
          <div style={{ flex: "1 1 250px", background: "rgba(17,17,17,0.6)", padding: "15px", borderRadius: "12px", border: "1px solid rgba(255,255,255,0.2)", color: "#fff" }}>
            <p><strong>Номер полета:</strong> {displayField(fly.flyNumber)}</p>
            <p><strong>Дата и время:</strong> {formatDateTime(fly.dateTime)}</p>
          </div>

          {/* Высоты и скорости */}
          <div style={{ flex: "1 1 250px", background: "rgba(17,17,17,0.6)", padding: "15px", borderRadius: "12px", border: "1px solid rgba(255,255,255,0.2)", color: "#fff" }}>
            <p><strong>Продолжительность полета:</strong> {displayField(fly.duration)} мин</p>
            <p><strong>После полета остался депозит:</strong> {displayField(fly.hasTime)} мин</p>
          </div>
        </div>

        {/* Комментарий */}
        <div style={{
          margin: "20px auto",
          background: "rgba(17,17,17,0.7)",
          padding: "20px",
          borderRadius: "12px",
          border: "1px solid rgba(255,255,255,0.2)",
          width: "100%",
          maxWidth: "900px",
          color: "#fff",
          textAlign: "center",
          overflowWrap: "break-word",
          boxSizing: "border-box",
        }}>
          <h3 style={{ color: "#6a85ddde", marginBottom: "10px" }}>Описание полета</h3> 
          <p style={{ whiteSpace: "pre-wrap", textAlign: "center", margin: 0 }}>
            {displayField(fly.comment)}
          </p>
        </div>

        {/* Кнопки навигации */}
        <div
          style={{
            marginTop: "20px",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            alignItems: "center",
          }}
        >
          <Link
            to="/tunnel"
            style={{
              padding: "10px 20px",
              backgroundColor: "#6a85ddde",
              color: "#000",
              textDecoration: "none",
              borderRadius: "8px",
              fontWeight: "bold",
            }}
          >
            ← Назад к списку полетов
          </Link>

          <Link
            to="/"
            style={{
              padding: "10px 20px",
              backgroundColor: "#6a85ddde",
              color: "#000",
              textDecoration: "none",
              borderRadius: "8px",
              fontWeight: "bold",
            }}
          >
            ← На главную
          </Link>
        </div>
      </div>

      {/* Модальное окно удаления */}
      {confirmOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
          }}
        >
          <div
            style={{
              background: "#111",
              padding: "30px",
              borderRadius: "15px",
              width: "350px",
              textAlign: "center",
              boxShadow: "0 10px 25px rgba(0,0,0,0.8)",
            }}
          >
            <h3 style={{ color: "#fff" }}>Удалить полет?</h3>
            <p style={{ color: "#aaa", marginTop: "10px" }}>
              Это действие нельзя отменить.
            </p>

            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <button
                onClick={() => setConfirmOpen(false)}
                style={{
                  padding: "8px 15px",
                  background: "#444",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              >
                Отмена
              </button>

              <button
                onClick={handleDelete}
                style={{
                  padding: "8px 15px",
                  background: "#DC2626",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              >
                Удалить
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FlyPage;